import axios from 'axios';

const config = require('../../../config/config.js');
const { domain, header, headerFile } = config;

export default {
  async login(data) {
    let result = false;
    const url = domain + '/login';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async uploadPhotoProfile(data) {
    let result = false;
    const url = domain + '/users/update/photo';
    let formData = new FormData();

    formData.append('access_token', data.access_token);
    formData.append('photo', data.photo);

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, formData, headerFile);
    }

    return result;
  },
  async updateProfile(data) {
    let result = false;
    const url = domain + '/users/update';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.put(url, data, header);
    }

    return result;
  },
  async deleteUser(data) {
    let result = false;
    const url = domain + '/users/delete-user';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async importUser(data) {
    let result = false;
    const url = domain + '/import-user';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
};
